module.exports = __webpack_public_path__ + "static/img/closeup-unrecognizable-businesswoman-talking-pills-office_637285-4666-1.64f807b3.png";